import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Auth interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Attach timestamp for duration tracking
  (config as any)._startTime = Date.now();
  return config;
});

// Logging interceptor — requests
api.interceptors.request.use(
  (config) => {
    console.log(
      `%c[API] --> ${config.method?.toUpperCase()} ${config.url}`,
      'color: #1565c0',
      config.data ? config.data : ''
    );
    return config;
  }
);

// Response + error logging
api.interceptors.response.use(
  (response) => {
    const duration = Date.now() - ((response.config as any)._startTime || Date.now());
    console.log(
      `%c[API] <-- ${response.status} ${response.config.method?.toUpperCase()} ${response.config.url} ${duration}ms`,
      'color: #16a34a'
    );
    return response;
  },
  async (error) => {
    const config = error.config;
    const duration = Date.now() - ((config as any)?._startTime || Date.now());
    const status = error.response?.status || 'NETWORK';

    console.error(
      `[API ERROR] <-- ${status} ${config?.method?.toUpperCase()} ${config?.url} ${duration}ms`,
      error.response?.data || error.message
    );

    // Token refresh on 401
    if (error.response?.status === 401 && !config._retry) {
      config._retry = true;
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          const { data } = await axios.post(`${API_BASE_URL}/auth/token/refresh/`, {
            refresh: refreshToken,
          });
          localStorage.setItem('access_token', data.access);
          if (data.refresh) localStorage.setItem('refresh_token', data.refresh);
          config.headers.Authorization = `Bearer ${data.access}`;
          console.log('%c[API] Token refreshed, retrying...', 'color: #f59e0b');
          return api(config);
        } catch {
          console.error('[API] Token refresh failed, redirecting to login');
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
